module.exports = __webpack_public_path__ + "img/messenger_btn.8e2571a0.png";